import Carousel from 'nuka-carousel';
import useResizeObserver from 'use-resize-observer';
import { useCallback, useState } from 'react';

import styles from './TestimonialCarousel.scss';
import { TestimonialCard } from './TestimonialCarousel.Card';

// $slicer-breakpoints: 0 700px 980px 1024; // slicer breakpoints

const BREAKPOINTS = [
  {
    name: 'mobile',
    predicate: (width) => width <= 700,
  },
  {
    name: 'desktop',
    predicate: (width) => true,
  },
];

const useBreakpoints = (breakpoints = BREAKPOINTS) => {
  const [breakpoint, setBreakpoint] = useState(undefined);
  const { ref } = useResizeObserver({
    onResize: useCallback(
      ({ width }) => {
        setBreakpoint(
          breakpoints.find(({ predicate }) => predicate(width))?.name
        );
      },
      [breakpoints]
    ),
  });

  return { ref, breakpoint };
};

export function TestimonialCarousel({ testimonials = [] }) {
  const { ref, breakpoint } = useBreakpoints();
  const nodes = testimonials.map((testimonial, index) => (
    <TestimonialCard key={index} {...testimonial.fields} />
  ));

  const resizeProps = {
    desktop: { cellSpacing: 55, slideWidth: '320px' },
    mobile: { cellSpacing: 45, slideWidth: '253px' },
  };

  return (
    <div className={styles.container} ref={ref}>
      <Carousel
        heightMode="max"
        cellAlign="center"
        cellSpacing={45}
        withoutControls={true}
        slideWidth="253px"
        edgeEasing="easeQuadOut"
        transitionMode="scroll3d"
        autoGenerateStyleTag={false}
        style={{ height: '310px' }}
        wrapAround
        autoplay
        autoplayInterval={5000}
        opacityScale={0.3}
        {...resizeProps[breakpoint]}
      >
        {nodes}
      </Carousel>
    </div>
  );
}
